(function(window){
	// 'use strict';
	function initTracker(){
  
	  var trackerObj = {};
  
	  /* Initializes the snowplow config */
	  function initConfig(appId, collectorUrl){
		  ;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
		  p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
		  };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
		  n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","//static.iris.informa.com/f23io39d.js","snowplow"));
  
		  window.snowplow('newTracker', 'sp1', collectorUrl , {
			   appId: appId,
			   discoverRootDomain: true,
			   cookieSameSite: 'Lax',
			   postPath:'/com.iiris/ed0',
			   contexts: {
				   performanceTiming: false
			   }
		  });

		  window.snowplow('setUserIdFromCookie', 'IRIS_ID');
		  
		  window.snowplow('enableActivityTracking', { 
			   minimumVisitLength: 30, 
			   heartbeatDelay: 30 
		  });


  
		  window.snowplow('enableLinkClickTracking');
		  window.snowplow('trackPageView');

		  let lastUrl = location.href; 

		  if('MutationObserver' in window){
			new MutationObserver(() => {
			  const url = location.href;
			  if (url !== lastUrl) {
				lastUrl = url;
				window.snowplow("trackPageView");
			  }
			}).observe(document, {subtree: true, childList: true});
		  }

		  trackerObj.collectorHost = collectorUrl;
		  trackerObj.appId = appId;
	  }
	  
	  /* Member functions will go here */	
	  trackerObj.trackImpression = function(data){
		window.snowplow("trackSelfDescribingEvent", {
			event: {
			  schema:
				"iglu:com.snowplowanalytics.snowplow/ad_impression/jsonschema/1-0-0",
			  data: data,
			},
		  });
	  };

	  trackerObj.trackStructEvt = function(data){
		if(data){
			window.snowplow('trackStructEvent', { category : data.cat, action: data.act, label :data.lbl, property: data.prop, value :data.val });
		}
	  };

	  trackerObj.initConfig = function(appId, collectorHost){
		  initConfig(appId, collectorHost);
	  };
  
	  trackerObj.setTrackingUID = function(userId){
	   if(userId){
		 document.cookie = "IRIS_ID="+userId +"; path=/;";
	   }
	   /* IRIS_ID is the cookie name, with userid as the value */
		window.snowplow('setUserIdFromCookie', 'IRIS_ID');
	  };
	  
	  trackerObj.clearTrackingUID = function() {
	   document.cookie = "IRIS_ID=; Max-Age=-99999999; path=/;";
	   window.snowplow('clearUserData');
	  };
	  
	  return trackerObj;
	}

	function getSnowplowDuid(cookieName) {
		cookieName = cookieName || '_sp_';
		var matcher = new RegExp(cookieName + 'id\\.[a-f0-9]+=([^;]+);?');
		var match = document.cookie.match(matcher);
		if (match && match[1]) {
		  return match[1].split('.')[0];
		} else {
		  return false;
		}
	}
  
	if(typeof(window.IIRISTracker) === 'undefined'){
	  window.IIRISTracker = initTracker();
	}
  })(window); 
